<template>
    <div class="home">
        <img src="../assets/Home2Typo.svg" id="home2Typo">
        <div id="textBox">
            <h2 class="brother">Treasure Peninsula 2025</h2>
            <p>The Department of Metalwork and Jewellery at Seoul National University
            will present over 60 contemporary artworks at "Treasure Peninsula 2025”, an exhibition held at super+CENTERCOURT during 
            Munich Jewellery Week.<br><br>
            Korea, a peninsula in East Asia with a longstanding tradition of metal craftsmanship, 
            introduced modern craft education at universities in the late 1960s. In just half a century, 
            metalwork in Korea has flourished, driven by a deep passion for contemporary practice and ongoing artistic exploration. 
            Seoul National University, in particular, has played a pivotal role in shaping modern metal craft education in Korea,
            cultivating generations of educators and artists through its undergraduate and graduate programs for 
            over five decades.<br><br>
            This exhibition marks the second installment following last year’s "Treasure Peninsula" at Munich Jewellery Week, 
            visualizing the journey of the works as they travel to Munich. The exhibition space incorporates shipping boxes 
            and packing materials as part of the installation, allowing visitors to engage with the 
            experience of unboxing packages from the Treasure Peninsula—revealing precious artwork sent from afar.<br><br>
            For the students of Seoul National University’s Metalwork and Jewellery Department, this exhibition is more than just
            a showcase—it is a testament to artistic vision, conceptual depth, and technical mastery. 
            This exhibition in Munich provides an opportunity to engage in critical discourse, challenge conventions, and refine
            creative direction through a range of perspectives. Visitors will encounter an eclectic collection of contemporary 
            jewellery, vessels, and sculptural objects, each demonstrating meticulous craftsmanship,
            material innovation, and a relentless pursuit of technical perfection, continuously expanding the boundaries of
            craftsmanship and artistic exploration.</p>
            <br><br>
            <p class="regular">Exhibition Director</p>
            <img src="../assets/CustomHr.svg" class="customHr">
            <p class="book">Prof. Jakyung Shin<br>BK prof. Soohyun Chou</p>
            <br>
            <p class="regular">Exhibition Team</p>
            <img src="../assets/CustomHr.svg" class="customHr">
            <p class="book">Soun Cho<br>Kyuman Hong<br>Bohee Jang<br>Pilho Kang<br>Eujin Kim</p>
            <img src="../assets/Home2Info.svg" id="home2Info">
            <div id="emptyBox"></div>
        </div>
    </div>
  </template>

<style scoped>
.home {
 background-image: url('../assets/SHome2Background.png');
 background-size: cover;
 overflow: auto;
}

#home2Typo {
    position: absolute;
    left: -3px;
    top: -3px;
    width: 80vw;
    height: auto;
}

#home2Info {
    position: absolute;
    right: 0px;
    bottom: 60px;
    width: 130px;
    height: auto;
}

#textBox {
    width: calc(100vw - 75px);
    position: absolute;
    left: 40px;
    top: calc(47vw);
    height: auto;
    text-align: left;
    padding-bottom: 60px;
}

#emptyBox {
    height: 110px;
    width: 100%;
}

h2 {
    font-family: brother-1816, sans-serif;
    font-weight: 700;
    font-style: normal;
    font-size: 13pt;
    color: #0D00B4;
}

p {
    font-family: brother-1816, sans-serif;
    font-weight: 200;
    font-style: normal;
    font-size: 9pt;
    color: black;
    line-height: 18pt;
    margin: 0px 0px 0px 0px;
}

.regular {
    font-family: brother-1816, sans-serif;
    font-weight: 400;
    font-style: normal;
    font-size: 9pt;
    margin: 0 0 0 0;
    line-height: 12pt;
}

.book {
    font-family: brother-1816, sans-serif;
    font-weight: 300;
    font-style: normal;
    font-size: 9pt;
    line-height: 12pt;
}

.customHr {
    position: relative;
    width: 30px;
    margin: 5px 0px 5px 0px;
}
</style>
  
<script setup>
import { useRouter } from 'vue-router'
const router = useRouter()
router.beforeEach(function(to, from, next){
  if(from.path == '/2' && to.path == '/') {
    to.meta.transition = 'slide-left'
    from.meta.transition = 'slide'
  }
  else {
    to.meta.transition = 'slide'
  }
  window.removeEventListener("touchstart",startevent);
  window.removeEventListener("touchend", endevent);
  next();
});

function startevent(event) {
  if(event.touches.length === 1){
    start = event.touches.item(0).clientX;
  }else{
    start = null;
  }
}

function endevent(event) {
  var offset = 100;
  if(start){
    var end = event.changedTouches.item(0).clientX;
    if(end > start + offset){
      router.push('/');
    }
    else if(end < start - offset ){
      router.push('/boxes');
    }
  }
}

var start = null;
window.addEventListener("touchstart",startevent);
window.addEventListener("touchend", endevent);
</script>
  